/**
 * @version 1.0
 * @author xieyq
 * @createTime 2022/2/23
 * @updateTime 2022/2/23
 * @decription 财产线索相关的js处理
 * @namespace 【ccxs】 财产线索
 */
// 添加编辑财产线索
import appGuaranteeAddCcxs from '../../addGuarantee/addCCXS/index.vue';
import {typeCclx} from "@/filters";
export default {
    // 依赖组件
    components: {appGuaranteeAddCcxs},
    // 数据
    data() {
        return {
            // 财产线索数据列表
            ccxsDataList: [],
            // 财产线索总数
            ccxsCount: 0,
            // 是否显示弹层
            showPopupCcxs: false,
            // 正在编辑的财产线索信息项
            ccxsEditItem: null,
            // 正在编辑的财产线索信息项索引
            ccxsEditIndex: -1,
            // 财产线索删除的id集合
            ccxsDelIds: [],
            // 财产线索加载完成
            ccxsLoaded: false
        };
    },
    computed: {
        // 财产线索id属性名
        ccxsIdProp() {
            return this.fromSQBG ? 'cYdbPpid' : 'cDbppid';
        }
    },
    // 方法
    methods: {
        /**
         * 财产线索数据
         * @param {Array<Object>} data 财产线索数据列表
         * @returns {void}
         * */
        initCcxsData(data) {
            // 财产线索数据列表
            const _ccxsDataList = [];
            // 财产线索总财产
            let _ccxsCount = 0;
            // 循环遍历数据处理数据
            data.forEach((item) => {
                // 财产线索类型文本
                item.cCclxText = typeCclx(item.cCclx);
                // 财产金额文本
                item.cSqbqccjeText = `${item.cSqbqccje}元`;
                // 财产所有人名称
                item.cSqdbccyyzText = this.ccxsGetCcsyrText(item);
                // 单条财产线索价值
                _ccxsCount += (Number(item.cSqbqccje) * 100);
                _ccxsDataList.push(item);
            });
            // 财产线索总财产
            this.ccxsCount = (_ccxsCount / 100).toFixed(2);
            // 赋值财产线索数据列表
            this.ccxsDataList = _ccxsDataList;
            // 财产线索加载完成
            this.ccxsLoaded = true;
        },

        /**
         * 获取财产线索展示的右侧文本
         * @param {Object} dataItem 财产线索信息项
         * @returns {String}
         * */
        ccxsGetShowTitle(dataItem) {
            return `${dataItem.cCclxText}：${dataItem.cSqdbccyyzText}`;
        },

        /**
         * 获取财产所有人姓名数据
         * @param {Object} dataItem 财产线索信息项
         * @returns {String}
         * */
        ccxsGetCcsyrText(dataItem) {
            let _dsrxm = '';
            this.bsqrDataList.some(bqbsqrItem => {
                if(bqbsqrItem[this.bsqrIdProp] === dataItem.cSqdbccyyz) {
                    _dsrxm = this.bsqrGetName(bqbsqrItem);
                    return true;
                }
                return false;
            });
            return _dsrxm;
        },

        /**
         * 更新财产线索对应的财产所有者名称
         * @param {Object} itemData 信息项数据
         * @returns {void}
         * */
        ccxsUpdateCcsyrTextByBsqr(itemData) {
            // 遍历所有财产线索列表数据进行名称的更新
            this.ccxsDataList.forEach(ccxsItem => {
                if (ccxsItem.cSqdbccyyz === itemData[this.bsqrIdProp]) {
                    ccxsItem.cSqdbccyyzText = this.bsqrGetName(itemData)
                }
            })
        },

        /**
         * 添加、编辑财产线索
         * @param {Object} item 财产线索信息项数据
         * @param {Number} index 索引
         * @returns {void}
         * */
        ccxsAddAEdit(item = null, index = -1){
            if (item) {
                this.ccxsEditItem = item;
                this.ccxsEditIndex = index;
            }
            // 生成财产线索表单
            this.showPopupCcxs = true;
        },

        /**
         * 删除财产线索
         * @param {String} ccxsid 财产线索id
         * @param {Number} index 当前财产线索索引
         * @returns {void}
         * */
        ccxsDelete(ccxsid, index) {
            // 财产线索总数
            let _ccxsCount = this.ccxsCount * 100;
            _ccxsCount -= Number(this.ccxsDataList[index].cSqbqccje) * 100;
            // 财产线索总数
            this.ccxsCount = (_ccxsCount / 100).toFixed(2);
            // 删除的id集合中存储对应的财产线索id
            !this.ccxsDataList[index].isAdd && this.ccxsDelIds.push(ccxsid);
            // 删除对应的复议财产线索
            this.ccxsDataList.splice(index, 1);
        },

        /**
         * 根据被申请人id删除对应的财产线索相关信息
         * @param {String} bsqrId 被申请人id
         * @returns {void}
         * */
        ccxsDeleteByBsqrId(bsqrId) {
            // 当前不存在财产线索列表，则直接返回
            if (!this.ccxsDataList.length) {
                return;
            }
            // 倒序排查方便删除
            for (let i = this.ccxsDataList.length - 1; i >=0; i--) {
                // 信息项
                const _item = this.ccxsDataList[i];
                // 财产所有者
                if (_item.cSqdbccyyz === bsqrId) {
                    // 删除对应的财产线索
                    this.ccxsDelete(_item[this.ccxsIdProp], i);
                }
            }
        },

        /**
         * 取消添加、编辑财产线索
         * @returns {void}
         * */
        ccxsCancel() {
            // 编辑信息项置为null
            this.ccxsEditItem = null;
            // 索引置为-1
            this.ccxsEditIndex = -1;
            // 财产线索弹层为false
            this.showPopupCcxs = false;
        },

        /**
         * 获取转化财产线索数据
         * @param {Object} formData 表单数据
         * @returns {Object} 转化之后的数据
         * */
        ccxsGetTransformData(formData) {
            const _transformData = {
                ...formData,
                // 财产金额文本
                cSqbqccjeText: `${formData.cSqbqccje}元`
            };
            return _transformData;
        },

        /**
         * 处理财产线索确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        ccxsHandlerConfirm(formData) {
            const _transformData = this.ccxsGetTransformData(formData);
            // 财产线索总数
            let _ccxsCount = this.ccxsCount * 100;
            // 如果编辑数据，则说明是编辑数据
            if (this.ccxsEditItem && this.ccxsEditIndex > -1) {
                _ccxsCount -= Number(this.ccxsDataList[this.ccxsEditIndex].cSqbqccje) * 100;
                // 进行数据替换
                this.ccxsDataList.splice(this.ccxsEditIndex, 1, _transformData);
            } else {
                // 申请变更的时候，需要将对应id赋值成cId
                _transformData[this.ccxsIdProp] = _transformData.cId;
                // 添加数据
                this.ccxsDataList.push(_transformData);
            }
            // 新增的时候需要对应的实际id赋值为cId
            _transformData.isAdd && (_transformData[this.ccxsIdProp] = _transformData.cId);
            // 单条财产线索价值
            _ccxsCount += (Number(formData.cSqbqccje) * 100);
            // 财产线索总数
            this.ccxsCount = (_ccxsCount / 100).toFixed(2);
        },

        /**
         * 添加、编辑财产线索表单确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        ccxsConfirm(formData) {
            // 确认处理操作
            this.ccxsHandlerConfirm(formData);
            // 财产线索取消为false
            this.ccxsCancel();
        },

        /**
         * 添加并继续
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        ccxsConfirmAContinue(formData) {
            // 确认处理操作
            this.ccxsHandlerConfirm(formData);
        }
    }
};
